// extracted by mini-css-extract-plugin
module.exports = {"clients":"clients-module--clients--3C18O","client":"clients-module--client--1UgZ2","main":"clients-module--main--CqJRz","meta":"clients-module--meta--1Wstn"};